import { ReportColumnNames } from '@spa/api';

import { ReportTableColumn, ReportTableConfigInterface } from '../../../app/shared/components';

export const AdjustmentsReportTableConfig = (visibleAccountColumn: boolean): ReportTableConfigInterface => {
    const config = {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Date',
                selector: ReportColumnNames.Date,
            }),
            new ReportTableColumn({
                label: 'Account',
                selector: ReportColumnNames.Account,
            }),
            new ReportTableColumn({
                label: 'Category',
                selector: ReportColumnNames.Category,
            }),
            new ReportTableColumn({
                label: 'Comment',
                selector: ReportColumnNames.Comment,
            }),
            new ReportTableColumn({
                label: 'Debit',
                selector: ReportColumnNames.Debit,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Credit',
                selector: ReportColumnNames.Credit,
                shifted: true
            }),
        ],
        hiddenColumnIds: [],
        disableColumnsOptions: true
    };

    if (!visibleAccountColumn) {
        config.columns = config.columns.filter(column => {
            return column.selector !== ReportColumnNames.Account;
        });
    }

    return config;
};

export const AdjustmentsReportTotalFeesTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Category',
                selector: ReportColumnNames.Category,
            }),
            new ReportTableColumn({
                label: 'Debit',
                selector: ReportColumnNames.Debit,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Credit',
                selector: ReportColumnNames.Credit,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Net',
                selector: ReportColumnNames.Net,
                shifted: true
            }),
        ],
        hiddenColumnIds: [],
        disableColumnsOptions: true
    };
};
